module.exports = __webpack_public_path__ + "static/media/banner_img.369f0931.png";